import {
  Analysis,
  MetadataValue,
  ObjectType,
  SavedSnippetMetadataV2,
} from 'generated/graphql';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { EntityLabel, ReasonLabel } from 'v2/core/entities/feedback/labels';
import { SentimentName } from 'v2/core/entities/fields';

export type SetSelectedLabels = (selectedLabels: FeedbackLabel[]) => void;

export interface Highlight {
  id?: number | string;
  startIDx: number;
  endIDx: number;
  sentiment?: SentimentName;
  labelType?: PredictionLabelType;
  labelText?: FeedbackLabel['displayName'];
}

export enum PredictionLabelType {
  Reason = 'reason',
  Entity = 'entity',
  Sentiment = 'user-sentiment',
  Search = 'search',
}

export enum FORUM_FEEDBACK_HEADER_TRUNCATE_LENGTH {
  Preview = 180,
  Default = 400,
}

export interface FeedbackCategoriesLabels {
  entityLabels: EntityLabel[];
  reasonLabels: ReasonLabel[];
}

export interface FeedbackMetadataField {
  objectID: string;
  key: string;
  queriable: boolean;
  isImportant: boolean;
  values: string[];
  objectType: ObjectType;
  isReference: boolean;
  metadataValue: MetadataValue;
  metadataFieldKey: string;
}

export type CollectionItem = Pick<
  Analysis,
  'id' | 'title' | 'editToken' | 'viewToken'
> & {
  eqlExpression: Analysis['context']['eqlExpression'];
  savedFeedbackMetadata?: {
    feedbackID: string;
    isFeedbackSaved?: boolean;
    snippetMetadataV2?: SavedSnippetMetadataV2[];
  }[];
};
